/**
 * Grid quantity validation utilities
 */

import type { GridValidationResult } from "../types/grid.js";

/**
 * Validate all grid quantities against warehouse-specific inventory
 * Checks each input against the available inventory and auto-corrects invalid values
 * @returns Validation result with success flag and error messages
 */
export function validateGridQuantities(): GridValidationResult {
  const errors: string[] = [];

  $(".warehouse_row").each(function () {
    const $row = $(this);
    const warehouseName = $row.attr("data-warehouse-name") ?? "Unknown";

    $row.find(".variant_cell").each(function () {
      const $cell = $(this);
      const $input = $cell.find(".variant_qty_input_directship");

      if ($input.length === 0) return;

      const userQty = parseInt($input.val() as string, 10) || 0;
      if (userQty <= 0) return;

      const warehouseInventory = parseInt(
        $cell.attr("data-variant-qty") ?? "0",
        10,
      );
      const clampedInventory = Math.max(warehouseInventory, 0);
      const variantTitle = $cell.attr("data-variant-title") ?? "Unknown";

      if (userQty > clampedInventory) {
        errors.push(
          `${variantTitle} at ${warehouseName}: requested ${userQty}, only ${clampedInventory} available`,
        );
        $input.val(clampedInventory > 0 ? clampedInventory : "");
        $input.addClass("error");
      }
    });
  });

  return {
    valid: errors.length === 0,
    errors,
  };
}
